import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import ChatPage from '../modules/apps/chats/ChatsPage'
import { DokmeeSettings } from '../modules/apps/settings/settingsList/MainSettings'
import SettingsPage from '../modules/apps/settings/SettingsPage'
import { useAuth } from '../modules/auth'
import TriggersPage from '../modules/apps/triggers/TriggersPage'
import CompanyPage from '../modules/apps/company/CompanyPage'
import { RolesListWrapper } from '../modules/apps/roles-list/RolesList'
import TrainingPage from '../modules/apps/training/EmbeddingsList'
import ScrappingPage from '../modules/apps/scrapping-wizard/ScrappingPage'
import ScrappingPagePDF from '../modules/apps/scrapping-wizard/ScrappingPagePDF'
import MergingPage from '../modules/apps/scrapping-wizard/MergingPage'
import AutomationPage from '../modules/apps/automations/AutomationPage'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const { currentUser }: any = useAuth()
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        {/* <Route path='auth/*' element={<Navigate to='/dashboard' />} /> */}
        <Route path='auth/*' element={<Navigate to='/chats' />} />

        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        {/* Lazy Modules */}
        <Route
          path='/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />

        <Route
          path='chats/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />

        <Route
          path='triggers/*'
          element={
            <SuspensedView>
              <TriggersPage />
            </SuspensedView>
          }
        />

        <Route
          path='companies/*'
          element={
            <SuspensedView>
              <CompanyPage />
            </SuspensedView>
          }
        />

        <Route
          path='automations/*'
          element={
            <SuspensedView>
              <AutomationPage />
            </SuspensedView>
          }
        />

        <Route
          path='roles/*'
          element={
            <SuspensedView>
              <RolesListWrapper />
            </SuspensedView>
          }
        />

        <Route
          path='users/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />

        <Route
          path='/settings/*'
          element={
            <SuspensedView>
              <SettingsPage />
            </SuspensedView>
          }
        />

        <Route
          path='/training/*'
          element={
            <SuspensedView>
              <TrainingPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
      <Route
        path='websiteWizard/*'
        element={
          <SuspensedView>
            <ScrappingPage />
          </SuspensedView>
        }
      />

      <Route
        path='pdfWizard/*'
        element={
          <SuspensedView>
            <ScrappingPagePDF />
          </SuspensedView>
        }
      />

      <Route
        path='merging/*'
        element={
          <SuspensedView>
            <MergingPage />
          </SuspensedView>
        }
      />
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
